module.exports = __webpack_public_path__ + "static/media/air-rifle.46baa169.jpg";